import { axiosClientv1 } from "./apiClient";
import { ApiResponse } from "../Types";

export interface PreBooking {
  id: string;
  resource_id: string;
  customer_id?: string | null;
  customer_name: string;
  phone: string;
  start_time: string;
  end_time: string;
  notes?: string;
  status: "Confirmed" | "Pending" | "Cancelled";
  resource_name?: string;
  resource_type?: string;
}

export const GetPreBookings = async (params?: {
  search?: string;
  status?: string;
  resource_id?: string;
  start_date?: string;
  end_date?: string;
  page?: number;
  limit?: number;
}): Promise<ApiResponse<PreBooking[]>> => {
  try {
    const response = await axiosClientv1.get(`/pre-bookings`, { params });
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to load pre-bookings.",
      data: [],
      error: {
        code: error?.response?.status || 500,
        type: "server_error",
      },
    };
  }
};

export const CreatePreBooking = async (payload: {
  resource_id: string;
  customer_id?: string | null;
  customer_name: string;
  phone: string;
  start_time: string;
  end_time: string;
  notes?: string;
  status?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/pre-bookings/create`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to create pre-booking.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const UpdatePreBooking = async (payload: {
  id: string;
  resource_id: string;
  customer_id?: string | null;
  customer_name: string;
  phone: string;
  start_time: string;
  end_time: string;
  notes?: string;
  status?: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/pre-bookings/update`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to update pre-booking.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};

export const DeletePreBooking = async (payload: {
  id: string;
}): Promise<ApiResponse<any>> => {
  try {
    const response = await axiosClientv1.post(`/pre-bookings/delete`, payload);
    return response.data;
  } catch (error: any) {
    return {
      success: false,
      message: error?.response?.data?.message || "Failed to delete pre-booking.",
      error: {
        code: error?.response?.status || 400,
        type: "bad_request",
      },
    };
  }
};
